import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./color_picker.less";

const COLORS = [
  ["#000000", "#000000"],
  ["#2358F8", "#4B75FF"],
  ["#ffb146", "#f79a22"],
  ["#b47df4", "#8f64f2"],
  ["#6ef29c", "#34da6c"]
];

const ColorPicker = ({ currentColor, handleClick }) => (
  <div className={css.root}>
    {COLORS.map(([color1, color2]) => (
      <div
        key={color1}
        className={classNames(css.item, { [css.current]: color1 === currentColor })}
        style={{ background: color1 }}
        onClick={() => handleClick(color1, color2)}
      />
    ))}
  </div>
);

ColorPicker.propTypes = {
  currentColor: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default ColorPicker;
